import { render, staticRenderFns } from "./CreateSettlement.vue?vue&type=template&id=0aa22a0a"
import script from "./CreateSettlement.vue?vue&type=script&lang=js"
export * from "./CreateSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports